(function ( $ ) {

	$.fn.flipimgbg = function ( options ) {
		var $elem = $( this ),
			dataTargetImg = $elem.data( 'target-image-container' ),
			$targetImgContainer = $elem.find( dataTargetImg );

		var init = function () {

			if ( dataTargetImg && $targetImgContainer.length > 0 ) {

				var $img,
					imgSrc;

				if ( $targetImgContainer.is( 'img' ) ) {
					$img = $targetImgContainer;
				} else {
					$img = $targetImgContainer.find( 'img' ).eq( 0 );
				}

				imgSrc = $img.attr( 'src' );

				$elem.css( {
					'background-image'    : 'url(' + imgSrc + ')',
					'background-size'     : 'cover',
					'background-position' : 'center center'
				} );

				$img.hide();


			}
		};

		init();
		return this;
	};

}( $ ));